import { useNavigate } from "react-router-dom";
import Badge from "../../../components/ui/Badge";
import { formatDate } from "../../../utils/date";
import { todayManilaKey } from "../../../utils/manilaTime";
import { cx } from "../../../utils/classNames";
import { getPersonName, isOverdue, REVIEWER_STATUS } from "../performanceUtils";
import ui from "../../../components/ui/ui.module.css";
import styles from "../Performance.module.css";

const COLUMN_COUNT = 6;

// Evaluator / approver list. Rows open `${basePath}/:id`.
const EvaluationsTable = ({ rows, basePath, emptyMessage }) => {
  const navigate = useNavigate();
  const today = todayManilaKey();

  return (
    <div className={ui.tableWrapper}>
      <table className={ui.table}>
        <thead>
          <tr>
            <th>Employee</th>
            <th>Branch</th>
            <th>Form</th>
            <th>Period</th>
            <th>Status</th>
            <th>Due</th>
          </tr>
        </thead>
        <tbody>
          {!rows.length && (
            <tr>
              <td
                colSpan={COLUMN_COUNT}
                className={cx(ui.muted, "text-center")}
              >
                {emptyMessage}
              </td>
            </tr>
          )}

          {rows.map((evaluation) => {
            const status = REVIEWER_STATUS[evaluation.status] ?? {
              label: evaluation.status,
              tone: "gray",
            };
            const overdue = isOverdue(evaluation, today);

            return (
              <tr
                key={evaluation.id}
                className={ui.clickableRow}
                onClick={() => navigate(`${basePath}/${evaluation.id}`)}
              >
                <td>
                  <div className={ui.strong}>
                    {getPersonName(evaluation.employee)}
                  </div>
                  <div className={ui.muted}>
                    {evaluation.employee?.employeeId}
                  </div>
                </td>
                <td>{evaluation.employee?.branch?.branchName ?? "—"}</td>
                <td>{evaluation.template?.name}</td>
                <td className={ui.noWrap}>{evaluation.periodLabel}</td>
                <td>
                  <Badge tone={status.tone}>{status.label}</Badge>
                </td>
                <td className={cx(ui.noWrap, overdue && styles.overdue)}>
                  {evaluation.dueDate ? formatDate(evaluation.dueDate) : "—"}
                  {overdue && " · Overdue"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default EvaluationsTable;
